import { render, staticRenderFns } from "./AnswerLayout.vue?vue&type=template&id=70674e8e&"
import script from "./AnswerLayout.vue?vue&type=script&lang=js&"
export * from "./AnswerLayout.vue?vue&type=script&lang=js&"
import style0 from "./AnswerLayout.vue?vue&type=style&index=0&id=70674e8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports